import { ViewProps } from './table.constants';
import { useStudentGetAnswers } from 'approot/activity-builder/student/answer/student-answer.hooks';
import { useBatchStudentAnswersContext } from '../shared/batch-student-answer.context';
import SubActivityView from '../sub-activity/sub-activity-view';
import TableViewFields from './table-view-fields';
import ComponentLoading from '../shared/component-loading';
import { ACTIVITIES_COMPONENT_TYPE_TABLE } from 'global/constants';
import { useActivityBuilderPresentContext } from 'approot/activity-builder/present/activity-builder-present.context';
import { AnswerSaveStatus } from '../shared/answer-save-status/answer-save-status';

const TableStudent = (
  props: ViewProps & {
    isLoggedIn: boolean;
  }
) => {
  const { id, type, subActivityProperties, isLoggedIn, properties } = props;

  const { componentAnswers, variables, hasFetchedAnswers, error } =
    useStudentGetAnswers({
      fetchPolicy: 'cache-first',
      componentId: id,
      skip: !isLoggedIn,
    });

  const { handleUpdate } = useBatchStudentAnswersContext();
  const { activeComponent, setActiveComponent } =
    useActivityBuilderPresentContext();

  return (
    <SubActivityView
      subActivityDetails={subActivityProperties}
      componentId={id}
      componentType={type}
      onClick={() => setActiveComponent({ id })}
    >
      {activeComponent?.id === id && !properties.table.isReadOnly && (
        <AnswerSaveStatus />
      )}
      <TableViewFields
        {...props}
        canRespond={isLoggedIn}
        answers={componentAnswers}
        updateAnswer={tableAnswer => {
          if (
            variables &&
            subActivityProperties?.activityComponentId &&
            isLoggedIn
          ) {
            handleUpdate({
              input: {
                __typename: 'ActivityAnswer',
                activityId: subActivityProperties?.activityComponentId,
                answerType: tableAnswer.answerType,
                componentId: id,
                uuid: tableAnswer.uuid,
                answer: tableAnswer.answer,
                answerReferences: tableAnswer.answerReferences,
                createdAt: new Date(),
                updatedAt: null,
                studentId: null,
              },
              variables,
              dataTrackingComponentType: ACTIVITIES_COMPONENT_TYPE_TABLE,
            });
          }
        }}
        onFocus={() => setActiveComponent({ id })}
      />
      {isLoggedIn && (
        <ComponentLoading hasData={hasFetchedAnswers} error={error} />
      )}
    </SubActivityView>
  );
};

export default TableStudent;
